import {
  BaseRemoveMessage,
  RemoveMessage,
} from 'actions/socket/socketReceiveDataAction'
import { MessengerItemTypes } from 'components/page/Chat/Messenger/Messenger.constants'
import { prepareMessagesStructure } from 'components/page/Chat/Messenger/Messenger.functions'

import { ChatMessengerState } from '../ChatMessengerState'

/**
 *
 * @param chatState
 * @param content тут есть отличие типов между удаление входящего и исходящего
 * В данной функции не нужны, но правильность типов.
 * @param type
 * @returns
 */
export const removeMessageFromChat = (
  chatState: ChatMessengerState,
  content: BaseRemoveMessage | RemoveMessage,
  type: MessengerItemTypes
) => {
  const removedMessageIndex = chatState.messages.findIndex(
    // На данном этапе есть поддержка только одного сообщения
    ({ id }) => id === content.removedMessagesIds[0]
  )
  if (removedMessageIndex > -1) {
    const removedMessage = chatState.messages[removedMessageIndex]
    chatState.messages[removedMessageIndex] = {
      ...removedMessage,
      type,
      removeAllowed: false,
    }
    return {
      ...chatState,
      messages: [...chatState.messages],
      messagesByDays: prepareMessagesStructure(chatState.messages),
    }
  }

  return {
    ...chatState,
  }
}
